export function normalizePresenceUserId(value) {
  if (value == null) return '';
  if (typeof value === 'string' || typeof value === 'number') {
    const normalized = String(value).trim().replace(/-DEVLOCAL$/i, '');
    return normalized === 'null' || normalized === 'undefined' || normalized === '[object Object]' ? '' : normalized;
  }
  if (typeof value?.toHexString === 'function') return String(value.toHexString()).trim();
  if (typeof value === 'object') {
    for (const key of ['userId', 'participantId', 'friendId', '_id', 'id']) {
      const normalized = normalizePresenceUserId(value[key]);
      if (normalized) return normalized;
    }
  }
  return '';
}

export function resolveContactIdentity(contact, selfId = '') {
  const source = contact && typeof contact === 'object' ? contact : {};
  const normalizedSelfId = normalizePresenceUserId(selfId);
  const participantCandidates = [
    source.friend,
    source.user,
    source.contact,
    source.participant,
    source.otherUser,
    source.fromUser,
    source.toUser,
    source.from,
    source.to,
  ].filter((candidate) => candidate != null);

  for (const candidate of participantCandidates) {
    const id = normalizePresenceUserId(candidate);
    if (id && id !== normalizedSelfId) {
      return { id, user: typeof candidate === 'object' ? candidate : source };
    }
  }

  for (const candidate of [source.friendId, source.participantId, source.userId]) {
    const id = normalizePresenceUserId(candidate);
    if (id && id !== normalizedSelfId) return { id, user: source };
  }

  const directId = normalizePresenceUserId(source._id || source.id);
  return directId && directId !== normalizedSelfId
    ? { id: directId, user: source }
    : { id: '', user: source };
}

export function presenceStateRejectionReason(previous, incoming, snapshotRequestedAt = 0) {
  const previousUpdatedAt = Number(previous?.updatedAt || 0);
  const incomingUpdatedAt = Number(incoming?.updatedAt || 0);
  if (previousUpdatedAt && incomingUpdatedAt && incomingUpdatedAt < previousUpdatedAt) return 'older_server_updated_at';
  const liveReceivedAt = Number(previous?._liveReceivedAt || 0);
  if (
    snapshotRequestedAt &&
    liveReceivedAt > snapshotRequestedAt &&
    (!incomingUpdatedAt || incomingUpdatedAt < previousUpdatedAt)
  ) {
    return 'snapshot_predates_live_event';
  }
  return '';
}

export function shouldApplyPresenceState(previous, incoming, snapshotRequestedAt = 0) {
  return !presenceStateRejectionReason(previous, incoming, snapshotRequestedAt);
}
